import React from 'react';
import { Chip } from '@mui/material';
import type { WorkItemStatus, PlanStatus } from '../types/models';

const statusColors: Record<string, { bg: string; color: string }> = {
  Backlog: { bg: 'rgba(136, 146, 168, 0.15)', color: '#8892A8' },
  Planned: { bg: 'rgba(108, 155, 255, 0.15)', color: '#6C9BFF' },
  InProgress: { bg: 'rgba(255, 183, 77, 0.15)', color: '#FFB74D' },
  Done: { bg: 'rgba(105, 240, 174, 0.15)', color: '#69F0AE' },
  Deferred: { bg: 'rgba(136, 146, 168, 0.15)', color: '#8892A8' },
  Cancelled: { bg: 'rgba(255, 82, 82, 0.10)', color: '#FF5252' },
  Draft: { bg: 'rgba(136, 146, 168, 0.15)', color: '#8892A8' },
  Proposed: { bg: 'rgba(108, 155, 255, 0.15)', color: '#6C9BFF' },
  Approved: { bg: 'rgba(105, 240, 174, 0.15)', color: '#69F0AE' },
  Active: { bg: 'rgba(255, 183, 77, 0.15)', color: '#FFB74D' },
  Adjusted: { bg: 'rgba(255, 138, 101, 0.15)', color: '#FF8A65' },
  Closed: { bg: 'rgba(136, 146, 168, 0.15)', color: '#8892A8' },
};

export default function StatusChip({ status }: { status: WorkItemStatus | PlanStatus }) {
  const style = statusColors[status] || statusColors.Backlog;
  return (
    <Chip
      label={status.replace(/([A-Z])/g, ' $1').trim()}
      size="small"
      sx={{ bgcolor: style.bg, color: style.color, fontWeight: 600 }}
    />
  );
}
